import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { GlobalService } from '../../services/global.service';

@Injectable()
export class ModalService {
  public modal$: Observable<any>;
  private modalNameSubject: Subject<any>;

  constructor(public global: GlobalService) {
    this.modalNameSubject = new Subject<any>();
    this.modal$ = this.modalNameSubject.asObservable();
  }

  add(modalName: string, data?: any) {
    if (modalName == 'add-edit-client' || modalName == 'create-advisor' || modalName == 'risk-tolerance') {
      this.global.displayFAB = false;
    }

    var modalObj = {
      modalName: modalName || '',
      data: data || {}
    }
    this.modalNameSubject.next(modalObj);
  }

  // remove() {
  //   this.selectedModal = {};
  // }

  // open() {
  //   this.selectedModal.open();
  // }

  close(){
    var modalObj = {
      modalName: 'close-now',
      data: {}
    }
    this.modalNameSubject.next(modalObj);
  }


  


  
}